module.exports = __webpack_public_path__ + "static/media/img_05.ca11d04d.png";